import { featureFlagClient } from '@trello/feature-flag-client';
import { Analytics } from '@trello/atlassian-analytics';
import { sendErrorEvent } from '@trello/error-reporting';

const unregisterWorkers = () => {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    if (registrations.length > 0) {
      console.log(`[SERVICE WORKER] Unregistering`);
      for (let i = 0; i < registrations.length; i++) {
        Analytics.sendOperationalEvent({
          actionSubject: 'serviceWorker',
          action: 'unregistered',
          source: 'appStartup',
        });
        registrations[i].unregister();
      }
    }
  });
};

const registerWorker = () => {
  navigator.serviceWorker
    .register('/service-worker.js')
    .then(() => {
      console.log('[SERVICE WORKER] Registered');
      Analytics.sendOperationalEvent({
        actionSubject: 'serviceWorker',
        action: 'registered',
        source: 'appStartup',
      });
    })
    .catch((registrationError) => {
      console.log('[SERVICE WORKER] Registration failed');
      sendErrorEvent(registrationError);
      unregisterWorkers();
    });
};

export const registerOrUnregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    const isServiceWorkerEnabled = featureFlagClient.get(
      'fep.service_worker',
      false,
    );

    featureFlagClient.on('fep.service_worker', false, (newValue) => {
      if (newValue === false) {
        unregisterWorkers();
      } else {
        registerWorker();
      }
    });

    if (isServiceWorkerEnabled) {
      registerWorker();
    } else {
      unregisterWorkers();
    }
  }
};
